var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{class:{ 'btn-watchlist': true, 'btn-active': _vm.active, 'btn-inactive': !_vm.active },attrs:{"flat":"","icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.addToWatchlist.apply(null, arguments)}}},[(_vm.active)?_c('v-icon',[_vm._v("visibility")]):_c('v-icon',[_vm._v("visibility_off")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }